import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CompleteIcon } from "../../../../assets/icons/complete.svg";
import T from "../../../../components/Typography";
import { colors } from "../../../../styles";
import Button from "../../../../components/Button";
import { employeeAccountPath } from "../../../../routes/paths";
import { useIsMobile } from "../../../../helpers/ui";
import Loader from "../../../../components/Loader";

const RequestCardSuccess = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        position: "absolute",
        left: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{ width: isMobile ? "90%" : "40%", textAlign: "center" }}
        className="flex flex-col items-center"
      >
        {isLoading ? (
          <Loader text="Ordering card..." />
        ) : (
          <>
            <CompleteIcon />
            <T variant="headingSm" sx={{ marginTop: "16px" }}>
              Request Successful
            </T>
            <T
              variant="mdReg"
              sx={{ marginTop: "16px" }}
              color={colors.gray_600}
            >
              Your new card is on it's way. You should see it in your mailbox in
              7-10 business days.
            </T>
            <Button onClick={() => navigate(employeeAccountPath)}>
              Take Me Back to My Account
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default RequestCardSuccess;
